class CoDrawerMenu extends HTMLElement {
    constructor() {
    super();
    }

    connectedCallback() {
        this._bindOpenStateObservers();
    }

  disconnectedCallback() {
    if (this._observers) {
      this._observers.forEach((observer) => observer.disconnect());
    }
  }

  _bindOpenStateObservers() {
    this._observers = [];

    this.querySelectorAll('.mobile-nav__item__first').forEach((li) => {
      const directTrigger = li.querySelector(
        ':scope > .mobile-nav__has-sublist .collapsible-trigger, :scope > .mobile-nav__has-sublist .mobile-nav__link--button'
      );
      if (!directTrigger) return;

      const observer = new MutationObserver(() => {
        li.classList.toggle('is-menu-open', directTrigger.classList.contains('is-open'));
      });

      observer.observe(directTrigger, { attributes: true, attributeFilter: ['class'] });
      this._observers.push(observer);
    });
  }
}

if (!customElements.get("co-drawer-menu")) {
	customElements.define("co-drawer-menu", CoDrawerMenu);
}